export const primaryColor = '#0053E2';
export const textColor = '#001E60';
export const inputBgColor = '#A9DDF7';
export const bgColor = '#a9dcf7';
export const buttonBgColor = '#0053E2';
export const tabBgColor = '#A9DDF7';
export const tabActiveBgColor = '#4DBDF5';
